import { render, staticRenderFns } from "./product-details-inventory.vue?vue&type=template&id=3bec3b42&scoped=true&"
import script from "./product-details-inventory.vue?vue&type=script&lang=js&"
export * from "./product-details-inventory.vue?vue&type=script&lang=js&"
import style0 from "./product-details-inventory.vue?vue&type=style&index=0&id=3bec3b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bec3b42",
  null
  
)

export default component.exports